module.exports = __webpack_public_path__ + "img/logo-globalbet.501b9664.png";